/**
 * Lazy-load volledige hero-afbeeldingen na window load (fade-in i.p.v. thumbnail).
 */
(function () {
  'use strict';

  function initHeroLazyLoad() {
    if (document.readyState === 'complete') {
      setTimeout(loadHeroImages, 250);
    } else {
      window.addEventListener('load', function () {
        setTimeout(loadHeroImages, 250);
      });
    }
  }

  function loadHeroImages() {
    const heroSections = document.querySelectorAll('.hero');

    heroSections.forEach(function (heroSection) {
      const thumbnails = heroSection.querySelectorAll('[data-thumbnail="true"]');

      thumbnails.forEach(function (thumbnail) {
        const wrapper = thumbnail.closest('.hero__image-wrapper');
        if (!wrapper) return;

        const fullImageContainer = wrapper.querySelector('[data-full-image="true"]');
        if (!fullImageContainer) return;

        const fullImage = document.createElement('img');
        fullImage.width = fullImageContainer.dataset.imageWidth || '';
        fullImage.height = fullImageContainer.dataset.imageHeight || '';
        fullImage.alt = fullImageContainer.dataset.imageAlt || '';
        fullImage.className = fullImageContainer.className;
        fullImage.sizes = fullImageContainer.dataset.imageSizes || '';
        fullImage.src = fullImageContainer.dataset.imageSrc || '';
        fullImage.srcset = fullImageContainer.dataset.imageSrcset || '';
        fullImage.setAttribute('data-testid', fullImageContainer.getAttribute('data-testid') || '');

        fullImageContainer.parentNode.replaceChild(fullImage, fullImageContainer);

        if (fullImage.complete && fullImage.naturalHeight !== 0) {
          triggerFadeIn(fullImage, thumbnail);
        } else {
          fullImage.addEventListener('load', function () {
            triggerFadeIn(fullImage, thumbnail);
          });

          fullImage.addEventListener('error', function () {
            console.warn('Hero image failed to load:', fullImage.src);
          });
        }
      });
    });
  }

  function triggerFadeIn(fullImage, thumbnail) {
    fullImage.classList.add('loaded');

    setTimeout(function () {
      if (thumbnail && thumbnail.parentNode) {
        thumbnail.style.display = 'none';
      }
    }, 650);
  }

  initHeroLazyLoad();
})();
